export const chartColors =
        ["#0098D0", "#007EB6", "#005A91", "#003E6E", "#001E47", "#4DB2E6", "#99D4F2", "#CCEAF8", "#0070A1", "#00638A", "#33A6D8", "#66B8E0", "#99CAE8", "#CCE0F0", "#E5F2F9", "#D04700", "#D06433", "#E6804D", "#F29B66", "#F6B28D", "#0078A6", "#005C80", "#00A8D6", "#33B8DF", "#4D9CD6", "#607D8B", "#B0C4D6", "#D0DFE8", "#A9BCC8", "#DDEAF3"]
    // [
    //     "#3366cc",
    //     "#dc3912",
    //     "#ff9900",
    //     "#109618",
    //     "#990099",
    //     "#0099c6",
    //     "#dd4477",
    //     "#66aa00",
    //     "#b82e2e",
    //     "#316395",
    //     "#3366cc",
    //     "#994499",
    //     "#22aa99",
    //     "#aaaa11",
    //     "#6633cc",
    //     "#e67300",
    //     "#8b0707",
    //     "#651067",
    //     "#329262",
    //     "#5574a6",
    //     "#3b3eac",
    //     "#b77322",
    //     "#16d620",
    //     "#b91383",
    //     "#f4359e",
    //     "#9c5935",
    //     "#a9c413",
    //     "#2a778d",
    //     "#668d1c",
    //     "#bea413",
    //     "#0c5922",
    //     "#743411"]
;